<template>
  <div class="d-flex justify-content-between mb-3">
    <div class="w-25 text-right mr-2">
      <label>{{ label }}</label>
    </div>
    <div class="w-75">
      <b-overlay
        id="overlay-background"
        :show="loading"
        spinner-small
        variant="light"
        opacity="0.85"
        blur="5px"
        rounded="sm"
      >
        <b-input-group size="sm">
          <b-form-input
            :class="!editing ? 'bg-white' : 'bg-light'"
            v-if="choices.length == 0"
            ref="theInput"
            v-model="currentValue"
            :readonly="!editing"
          ></b-form-input>

          <b-form-input
            class="bg-white"
            v-if="choices.length > 0 && !editing"
            :value="choiceText"
            :readonly="!editing"
          ></b-form-input>
          <b-form-select
            v-if="choices.length > 0 && editing"
            ref="theSelect"
            v-model="currentValue"
            :options="choices"
          ></b-form-select>

          <b-input-group-append>
            <b-button
              v-if="!editing"
              @click="edit()"
              variant="outline-secondary"
              >Засах</b-button
            >
            <b-button
              v-if="editing"
              @click="cancel()"
              variant="outline-secondary"
              >Болих</b-button
            >
            <b-button v-if="editing" @click="save()" variant="primary"
              >Хадгалах</b-button
            >
          </b-input-group-append>
        </b-input-group>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import OwnerService from "../api-services/owner.service";
import Swal from "sweetalert2";
const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  icon: "success",
  timer: 3000,
  timerProgressBar: true,
  showConfirmButton: false,
});
export default {
  props: {
    label: {
      required: true,
    },
    value: {
      required: true,
    },
    paramName: {
      required: true,
    },
    choices: {
      required: false,
      default() {
        return [];
      },
    },
    validator: null
  },
  data() {
    return {
      editing: false,
      loading: false,
      currentValue: null,
      origValue: null,
      isError: false
    };
  },
  watch: {
    value(newVal) {
      this.origValue = newVal;
      this.currentValue = this.origValue;
    },
  },
  mounted() {
    this.origValue = this.value;
    this.currentValue = this.origValue;
  },
  computed: {
    choiceText() {
      const that = this;
      const selectedChoice = this.choices.filter((c) => {
        return c.value == that.currentValue;
      });
      if (selectedChoice.length > 0) {
        return selectedChoice[0].text;
      }
      return "-";
    },
  },
  methods: {
    edit() {
      if (!this.loading) {
        this.editing = true;
        this.$nextTick(() => {
          if (this.choices.length > 0) {
            this.$refs.theSelect.focus();
          } else {
            this.$refs.theInput.focus();
          }
        });
      }
    },

    async save() {
      if(this.validator != null) {
        const validation = this.validator(this.currentValue);
        if(!validation.isOk) {
          Toast.fire({
            animation: true,
            icon: "warning",
            title: validation.message,
          });
          return ;
        }
      }
      if (this.currentValue !== "") {
        this.loading = true;

        const saveData = {
          param: this.paramName,
          value: this.currentValue,
        };

        const { data } = await OwnerService.updateProfile(saveData);

        if (this.currentValue !== this.origValue) {
          console.log(data);
          this.origValue = this.currentValue;
          Toast.fire({
            animation: true,
            title: this.label + " амжилттай шинэчилэгдлээ",
          });
        }
        this.loading = false;
        this.editing = false;
      } else {
        Toast.fire({
          animation: true,
          icon: "warning",
          title: this.label + " хоосон хадгалах боломжгүй",
        });
      }
    },

    cancel() {
      if (!this.loading) {
        this.currentValue = this.origValue;
        this.editing = false;
      }
    },
  },
};
</script>
